import { Query } from '@/_core/cqrs/types/queries';

export class BoardActivityPanelQuery extends Query<BoardActivityPanelQueryResult> {
    constructor(public StorymapId: string) {
        super('BoardActivityPanelQuery');
    }
}

export class BoardActivityUnseenCountQuery extends Query<BoardActivityUnseenCountResult> {
    constructor(public StorymapId: string) {
        super('BoardActivityUnseenCountQuery');
    }
}

export interface BoardActivityPanelQueryResult {
    Activities: any[]; // PascalCase from backend — mapped to camelCase before store entry
    TotalCount: number;
}

export interface BoardActivityUnseenCountResult {
    UnseenCount: number;
    LatestRelevantActivityId: string | null;
}
